import type { TFunction } from 'i18next';
import type { ApplicabilityEditorCopy } from '../ApplicabilityEditor/ApplicabilityEditorMolecule';

const KEY = 'studio.typeEditor.relationships';

/**
 * The scope editor's wording for a RELATIONSHIP.
 *
 * `ApplicabilityEditorMolecule`'s defaults describe a CONTEXT ("this context can be opened
 * from any sphere"), which is a false statement about a relationship's other end. Both sheets
 * that host the editor — declaring a relationship, and adjusting an inherited one — state the
 * same thing about the same rule, so the wording lives here rather than being typed twice and
 * drifting. Each sheet still supplies its own `lead` / `anyNote`, which are the only two lines
 * that differ: one is about a rule being authored, the other about a rule being replaced.
 */
export const relationshipScopeCopy = (t: TFunction): ApplicabilityEditorCopy => ({
  familyHint: t(`${KEY}.scopeFamilyHint`),
  specificHint: (types: string) => t(`${KEY}.scopeSpecificHint`, { types }),
  conditionsEmpty: t(`${KEY}.scopeConditionsEmpty`),
  carriedOverTitle: t(`${KEY}.scopeCarriedOver`),
  unmappedNote: (count: number) => t(`${KEY}.scopeUnmapped`, { count }),
  legacyNote: (rows: string[]) => ({
    before: t(`${KEY}.scopeLegacyBefore`, { count: rows.length, rows: rows.join(' · ') }),
    mode: t('context.editor.applicabilityCustomFilter'),
    after: t(`${KEY}.scopeLegacyAfter`, { count: rows.length }),
  }),
});
